import logo from 'assets/logo.png';
import { Link } from 'react-router-dom';

export const Logo = () => {
  return (
    <Link to="/">
      <img className="h-24" src={logo} alt="finablr" />
    </Link>
  );
};
